const getters = {
  'welcomeMsg': state => state.welcomeMsg,
  'user': state => state.user
}
export default getters
